<template>
    <div class="payout-denominations-grid">



        <PayoutDenominationTile v-for="(denomination, index) in denominations" :key="index" 
            @click="selectDenomination(denomination.id)" :denominationId="denomination.id">

            <template v-slot:currency>{{ denomination.currency }}</template>
            <template v-slot:amount>{{ denomination.currency_amount }}</template>
            <template v-slot:coins>{{ denomination.coins_amount }}</template>

        </PayoutDenominationTile>



    </div>
</template>


<script setup>

import { computed } from 'vue';
import { PayoutStore } from '@/store/PayoutStore';
import PayoutDenominationTile from '@/components/Tiles/Rewards/Payout-Denomination-Tile.vue';

const payoutStore = PayoutStore();


const selectedPayoutOption = computed(() => {
    return payoutStore.SelectedPayoutOption;
});

const denominations = computed(() => {
    return selectedPayoutOption.value?.denominations || [];
});


const selectDenomination = (denominationId) => {
    payoutStore.setSelectedDenomination(denominationId)
}

</script>